import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import accountHelpers from '../../../../../utils/accountHelpers';
import {
  addScriptNoteRequest,
  getScriptsNotesRequest, scriptNoteOrAttachmentIds,
} from '../../../../../store/actions/script';
import classes from './tabs.module.scss';
import avatar from '../../../../../assets/icons/avatar.png';
import Button from '../../../../_common/Form/Buttons/Button';
import NoteModal from '../../../../_common/Modal/NoteModal/NoteModal';
import Loader from '../../../../_common/Loader/Loader';
import Checkbox from '../../../../_common/Form/Checkbox/Checkbox';
import Utils from '../../../../../utils/utils';

const Notes = ({ changeCount }) => {
  const isPatient = accountHelpers.isInOneOfRoles(['Patient', 'Health']);

  const historyTabRef = document.getElementById('rx-history-id');

  const dispatch = useDispatch();
  const {
    scriptNotes, notesRequestStatus, notesId, scrollingToNoteId,
  } = useSelector((store) => store.script);
  const { scriptId } = useParams();
  const noteRef = useRef(null);

  const [isOpenModal, setIsOpenModal] = useState(false);
  const [requestData, setRequestData] = useState({
    scriptId,
    name: accountHelpers.getUser().name,
    note: '',
    privateBody: false,
    userId: accountHelpers.getUser().id,
  });

  const allScriptNoteIds = scriptNotes.map((s) => s.noteId);
  const isCheckedAllScriptNoteIds = allScriptNoteIds.every((id) => notesId.includes(id));

  useEffect(() => {
    dispatch(getScriptsNotesRequest({
      scriptId,
      userId: accountHelpers.getUser().id,
    }));

    dispatch(scriptNoteOrAttachmentIds({ name: 'note', ids: [] }));
  }, [scriptId]);

  useEffect(() => {
    if (scrollingToNoteId && notesRequestStatus === 'success') {
      Utils.animateScrollTo(`#notes_id_${scrollingToNoteId}`, -80);
    }
  }, [scrollingToNoteId, notesRequestStatus]);

  const changeTextArea = (value) => {
    setRequestData((prev) => ({ ...prev, note: value }));
  };

  const changeCheckbox = (checked) => {
    setRequestData((prev) => ({ ...prev, privateBody: checked }));
  };

  const onSndNoteClick = async () => {
    if (!requestData.note) {
      toast.error('Please write note');
      return;
    }

    const { status } = await dispatch(addScriptNoteRequest(requestData));
    if (status === 'ok') {
      await dispatch(getScriptsNotesRequest({
        scriptId,
        userId: accountHelpers.getUser().id,
      }));

      await setRequestData((prev) => ({ ...prev, private: false, note: '' }));
      await setIsOpenModal(false);

      changeCount('Notes');

      window.scrollTo(0, noteRef.current.offsetTop);
    }
  };

  const onCheckBoxChange = (ids) => {
    if (ids === 'all') {
      if (isCheckedAllScriptNoteIds) {
        dispatch(scriptNoteOrAttachmentIds({ name: 'note', ids: [] }));
      } else {
        dispatch(scriptNoteOrAttachmentIds({ name: 'note', ids: allScriptNoteIds }));
      }
    } else if (notesId.some((s) => s === ids)) {
      dispatch(scriptNoteOrAttachmentIds({ name: 'note', ids: notesId.filter((s) => s !== ids) }));
    } else {
      dispatch(scriptNoteOrAttachmentIds({ name: 'note', ids: [...notesId, ids] }));
    }
  };

  return (
    notesRequestStatus !== 'success'
      ? (
        <div className={classes.note_loader}>
          <Loader />
        </div>
      )
      : (
        <div ref={noteRef} className={classes.script_note_wrapper}>
          <div className={classes.note_copy}>
            {notesRequestStatus === 'success' && !!scriptNotes.length && !isPatient
                && (
                <div>
                  <Checkbox
                    labelMarginLeft={14}
                    onChange={() => onCheckBoxChange('all')}
                    label="Copy to all"
                    checked={isCheckedAllScriptNoteIds}
                  />
                </div>
                )}

            {!!notesId.length && (
            <div>
              <div className={classes.note_button_header}>
                <Button
                  reverseColor
                  title="Copy"
                  onClick={() => historyTabRef.click()}
                  buttonColor="#5F6C8E"
                />
              </div>

              {/* <div className={classes.note_button_header}> */}
              {/*  <Button */}
              {/*    buttonColor="#5F6C8E" */}
              {/*    title="Cancel" */}
              {/*    onClick={() => dispatch(notesId([]))} */}
              {/*  /> */}
              {/* </div> */}
            </div>
            )}

          </div>

          <div>
            {!scriptNotes.length
              ? <div className={classes.notResult}>No Data Found</div>

              : (scriptNotes.map((s) => (
                <div
                  key={s.noteId}
                  id={`notes_id_${s.noteId}`}
                  className={`${classes.note_wrapper} ${notesId.includes(s.noteId)
                    ? classes.active : ''}`}
                >
                  {!isPatient && (
                  <div className={classes.note_checkbox}>
                    <Checkbox
                      onChange={() => onCheckBoxChange(s.noteId)}
                      checked={notesId.includes(s.noteId)}
                      disabled={!!isPatient}
                    />
                  </div>
                  )}

                  <div className={classes.note_img}>
                    <img
                      src={s.User.link}
                      alt="avatar"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = avatar;
                      }}
                    />
                  </div>

                  <div className={classes.note_text_wrapper}>
                    <div>
                      <div>
                        <span>{s.User.name}</span>

                        <span>
                          {moment.utc(s.createdAt).local().calendar({
                            sameDay: 'LT',
                            nextDay: 'DD.MM  LT',
                            nextWeek: 'DD.MM  LT',
                            lastDay: 'DD.MM  LT',
                            lastWeek: 'DD.MM  LT',
                            sameElse: 'DD.MM  LT',
                          })}
                        </span>
                      </div>

                      {!isPatient && <span>{`Make ${s.scriptNote.private ? 'private' : 'public'}`}</span>}
                    </div>

                    <p>{s.scriptNote.note}</p>
                  </div>
                </div>
              )))}
          </div>

          <div className={classes.note_button_wrapper}>
            <Button
              reverseColor
              title="Post"
              onClick={() => setIsOpenModal(true)}
              addPostButton
            />
          </div>

          <NoteModal
            isOpenModal={isOpenModal}
            onChangeCheckbox={changeCheckbox}
            onClose={() => setIsOpenModal(false)}
            textValue={requestData.note}
            onChangeText={changeTextArea}
            checkedValue={requestData.privateBody}
            saveNote={onSndNoteClick}
          />
        </div>
      )
  );
};

Notes.propTypes = {
  changeCount: PropTypes.func.isRequired,
};

export default Notes;
